import React from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';
import { sfHeadline } from './sectionHelpers';

const ContentRichText: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;
  return (
    <article style={{ padding: '80px 24px' }}>
      <div style={{ maxWidth: 768, margin: '0 auto' }}>
        {(sfHeadline(c) !== undefined || true) && (
          <InlineEditText
            tag="h2"
            controlKey="headline"
            style={{ marginBottom: 24 }}
          >
            {sfHeadline(c, 'Article Headline')}
          </InlineEditText>
        )}
        <InlineEditText
          tag="div"
          controlKey="body"
          style={{ color: '#64748b', lineHeight: 1.8, whiteSpace: 'pre-wrap' }}
        >
          {c.body || 'Your content goes here. Click to edit.'}
        </InlineEditText>
      </div>
    </article>
  );
};

export default ContentRichText;
